module.exports = __webpack_public_path__ + "img/icon-history-sell.3061ff09.svg";